import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    custom: {
      white: string;
      black?: string;
      link?: string;
      gradientLight?: string;
      gradientDark?: string;
      green?: string;
      red?: string;
      orange?: string;
    };
  }

  interface PaletteOptions {
    custom: {
      white: string;
      black?: string;
      link?: string;
      gradientLight?: string;
      gradientDark?: string;
      green?: string;
      red?: string;
      orange?: string;
    };
  }
}

export const responsiveFontSize = (size: number) => {
  switch (size) {
    case 9:
      return "clamp(0.45rem, 3vw,  0.563rem)";
    case 10:
      return "clamp(0.48rem, 3vw, 0.625rem)";
    case 11:
      return "clamp(0.5rem, 3vw, 0.688rem)";
    case 12:
      return "clamp(0.6rem, 3vw, 0.75rem)";
    case 13:
      return "clamp(0.72rem, 3vw,  0.813rem)";
    case 14:
      return "clamp(0.75rem, 3vw,  0.875rem)";
    case 15:
      return "clamp(0.8rem, 3vw, 0.938rem)";
    case 16:
      return "clamp(0.875rem, 3vw, 1rem)";
    case 18:
      return "clamp(0.95rem, 3vw, 1.125rem)";
    case 19:
      return "clamp(0.98rem, 3vw, 1.188rem)";
    case 20:
      return "clamp(1rem, 3vw, 1.25rem)";
    case 21:
      return "clamp(1.1rem,3vw,1.313rem)";
    case 22:
      return "clamp(1.15rem,3vw, 1.375rem)";
    case 24:
      return "clamp(1.2rem,3vw, 1.5rem)";
    case 26:
      return "clamp(1.3rem,3vw, 1.625rem)";
    case 30:
      return "clamp(1.35rem,3vw, 1.875rem)";
    case 35:
      return "clamp(1.8rem,3vw, 2.188rem)";
    case 40:
      return "clamp(1.8rem, 3vw,2.5rem)";
    case 45:
      return "clamp(2.3rem, 3vw,2.813rem)";
    case 48:
      return "clamp(2.7rem, 3vw,3rem)";
    case 50:
      return "clamp(2.8rem, 4vw,3.125rem)";
    case 55:
      return "clamp(3.2rem, 4vw,3.438rem)";
    case 64:
      return "clamp(3.5rem, 3vw, 4rem)";
    case 75:
      return "clamp(3.2rem, 3vw, 4.688rem)";
    case 80:
      return "clamp(4.5rem, 4vw, 5rem)";
    default:
      return "clamp(0.875rem, 3vw, 1rem)";
  }
};

const theme = createTheme({
  palette: {
    primary: {
      main: "rgba(15, 80, 81, 1)",
      dark: "rgb(2, 42, 44)",
      light: "rgba(46, 218, 220, 1)",
    },
    secondary: {
      main: "rgba(255, 248, 231, 1)",
    },
    background: {
      default: "rgba(255,255,255,1)",
      paper: "rgba(245, 245, 246, 1)",
    },
    text: {
      primary: "#000000",
      secondary: "rgba(119, 126, 144, 1)",
      disabled: "#a9a9a9",
    },
    custom: {
      white: "#ffffff",
      black: "#000000",
      link: "#0e6ba8",
      gradientLight: "rgba(46, 218, 220, 1)",
      gradientDark: "rgba(25, 117, 118, 1)",
      green: "rgba(59, 161, 67, 1)",
      red: "rgb(200, 36, 36)",
      orange: "rgb(238, 152, 32)",
    },
  },

  typography: {
    fontFamily: "Good Sans, Arial, sans-serif",
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "0.625em", // Border radius
          "& fieldset": {
            borderColor: "rgba(232, 232, 232, 1)", // Border color
          },
          "&:hover fieldset": {
            borderColor: "rgba(232, 232, 232, 1)", // Border color on hover
          },
          "&.Mui-focused fieldset": {
            borderColor: "rgba(232, 232, 232, 1)", // Border color when focused
          },
        },
      },
    },
  },
});
export default theme;
